/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {LocalNetworkProfile} from '../../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-currency-form-control',
  template: `
    <div>
      <div>
        <select *ngIf="currencies.length > 1"
                class="form-control"
                [name]="name + '.currency'"
                [(ngModel)]="model[param]"
                style="width: auto;">
          <option [ngValue]="null">--</option>
          <option *ngFor="let currency of currencies" [ngValue]="currency">{{ currency }}</option>
        </select>
      </div>
    </div>
  `
})
export class CurrencyFormControlComponent implements OnInit {
  @Input() model: any;
  @Input() param: string;
  @Input() name: string;
  @Input() availableCurrencies: string[];

  currencies: string[] = [];

  constructor(@Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any) {
  }

  ngOnInit(): void {
    if (this.availableCurrencies) {
      this.currencies = this.availableCurrencies;
      return;
    }
    const defaultCurrency = this.LocalNetworkProfile.get('defaultCurrency');
    this.currencies = _.orderBy(this.LocalNetworkProfile.get('availableCurrencies'), (curr: string) => {
      return curr === defaultCurrency ? 0 : 1;
    });
  }
}
